var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInternetPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "426px",
    height: "426px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.99
    },
    fill: "#fefefe",
    d: "M 357.5,288.5 C 356.833,288.5 356.5,288.833 356.5,289.5C 350.277,290.617 345.944,294.117 343.5,300C 339.833,300.667 336.167,300.667 332.5,300C 328.806,293.969 323.639,289.803 317,287.5C 316.5,253.835 316.333,220.168 316.5,186.5C 319.249,186.726 321.916,186.393 324.5,185.5C 325.77,181.119 325.77,176.785 324.5,172.5C 324.5,172.167 324.5,171.833 324.5,171.5C 323.618,163.958 322.285,156.625 320.5,149.5C 320.5,147.167 320.5,144.833 320.5,142.5C 320.737,141.209 320.404,140.209 319.5,139.5C 319.5,138.5 319.5,137.5 319.5,136.5C 319.768,134.901 319.434,133.568 318.5,132.5C 318.54,129.119 318.207,125.786 317.5,122.5C 317.768,120.901 317.434,119.568 316.5,118.5C 316.384,115.14 316.051,111.807 315.5,108.5C 314.938,105.454 314.271,102.454 313.5,99.5C 313.5,97.8333 313.5,96.1667 313.5,94.5C 313.101,90.9891 312.434,87.6557 311.5,84.5C 311.662,82.4727 311.495,80.4727 311,78.5C 310.617,77.944 310.117,77.6107 309.5,77.5C 309.389,76.8826 309.056,76.3826 308.5,76C 280.5,75.6667 252.5,75.3333 224.5,75C 221.945,71.7407 218.945,69.4074 215.5,68C 222.188,74.6525 229.188,80.8192 236.5,86.5C 241.33,92.163 246.663,97.3296 252.5,102C 251.619,102.708 250.953,103.542 250.5,104.5C 248.863,105.218 247.197,105.384 245.5,105C 241.5,101 237.5,97 233.5,93C 232.833,92.3333 232.167,92.3333 231.5,93C 235,96.5 238.5,100 242,103.5C 242.5,121.497 242.667,139.497 242.5,157.5C 219.833,157.5 197.167,157.5 174.5,157.5C 174.5,139.5 174.5,121.5 174.5,103.5C 174.5,103.167 174.5,102.833 174.5,102.5C 172.537,103.684 170.537,104.517 168.5,105C 167.167,103.667 165.833,102.333 164.5,101C 165.71,99.9609 166.71,98.7942 167.5,97.5C 170.427,96.2427 172.761,94.2427 174.5,91.5C 177.764,89.9059 180.431,87.5725 182.5,84.5C 187.801,80.5336 192.801,76.2003 197.5,71.5C 195.456,72.0312 193.789,73.1978 192.5,75C 178.837,75.4999 165.171,75.6666 151.5,75.5C 163.536,68.9747 175.536,62.1414 187.5,55C 214.186,39.7149 242.852,31.2149 273.5,29.5C 320.355,31.5617 355.855,52.5617 380,92.5C 395.946,117.395 406.612,144.395 412,173.5C 414.239,187.241 413.905,200.908 411,214.5C 401.954,242.773 385.454,265.607 361.5,283C 360.335,284.992 359.002,286.825 357.5,288.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#616060",
    d: "M 205.5,64.5 C 208.186,60.5311 210.853,60.6978 213.5,65C 211.613,65.1626 210.113,64.3293 209,62.5C 208.184,63.8228 207.017,64.4894 205.5,64.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6e6e6d",
    d: "M 205.5,64.5 C 203.431,67.5725 200.764,69.9059 197.5,71.5C 199.569,68.4275 202.236,66.0941 205.5,64.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.816
    },
    fill: "#272726",
    d: "M 148.5,75.5 C 148.5,75.8333 148.5,76.1667 148.5,76.5C 133.485,76.1673 118.485,76.5007 103.5,77.5C 102.754,78.7362 102.421,80.0695 102.5,81.5C 101.833,82.1667 101.167,82.8333 100.5,83.5C 100.779,80.8822 101.446,78.3822 102.5,76C 117.83,75.5001 133.163,75.3334 148.5,75.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#575757",
    d: "M 197.5,71.5 C 192.801,76.2003 187.801,80.5336 182.5,84.5C 184.628,81.8697 186.961,79.3697 189.5,77C 175.837,76.5001 162.171,76.3334 148.5,76.5C 148.5,76.1667 148.5,75.8333 148.5,75.5C 149.5,75.5 150.5,75.5 151.5,75.5C 165.171,75.6666 178.837,75.4999 192.5,75C 193.789,73.1978 195.456,72.0312 197.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5a5a59",
    d: "M 309.5,77.5 C 282.209,76.3508 254.876,76.1841 227.5,77C 230.704,80.0359 233.704,83.2026 236.5,86.5C 229.188,80.8192 222.188,74.6525 215.5,68C 218.945,69.4074 221.945,71.7407 224.5,75C 252.5,75.3333 280.5,75.6667 308.5,76C 309.056,76.3826 309.389,76.8826 309.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ccdbe1",
    d: "M 148.5,76.5 C 162.171,76.3334 175.837,76.5001 189.5,77C 186.961,79.3697 184.628,81.8697 182.5,84.5C 181.244,84.4614 180.244,84.9614 179.5,86C 153.835,86.5 128.169,86.6666 102.5,86.5C 102.5,84.8333 102.5,83.1667 102.5,81.5C 102.421,80.0695 102.754,78.7362 103.5,77.5C 118.485,76.5007 133.485,76.1673 148.5,76.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ccdbe1",
    d: "M 309.5,77.5 C 309.963,80.4824 310.296,83.4824 310.5,86.5C 286.5,86.5 262.5,86.5 238.5,86.5C 237.833,86.5 237.167,86.5 236.5,86.5C 233.704,83.2026 230.704,80.0359 227.5,77C 254.876,76.1841 282.209,76.3508 309.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#787878",
    d: "M 196.5,82.5 C 199.516,78.2981 203.183,75.1315 207.5,73C 204.236,76.7729 200.57,79.9396 196.5,82.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f5e5e",
    d: "M 210.5,73.5 C 210.897,72.475 211.563,72.3083 212.5,73C 216.833,77.3333 221.167,81.6667 225.5,86C 224.833,86.6667 224.167,86.6667 223.5,86C 219.298,81.6298 214.964,77.4632 210.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.989
    },
    fill: "#fefefe",
    d: "M 100.5,83.5 C 100.497,88.5275 100.164,93.5275 99.5,98.5C 99.5,98.8333 99.5,99.1667 99.5,99.5C 99.0371,102.482 98.7038,105.482 98.5,108.5C 98.5,109.5 98.5,110.5 98.5,111.5C 97.5975,114.391 97.2641,117.391 97.5,120.5C 96.5655,121.568 96.2322,122.901 96.5,124.5C 96.5,127.167 96.5,129.833 96.5,132.5C 95.5489,133.919 95.2155,135.585 95.5,137.5C 94.3681,147.486 93.3681,157.486 92.5,167.5C 92.5,169.167 92.5,170.833 92.5,172.5C 91.7308,175.435 91.0641,178.435 90.5,181.5C 90.4534,183.038 91.1201,184.038 92.5,184.5C 92.6107,185.117 92.944,185.617 93.5,186C 96.146,186.497 98.8127,186.664 101.5,186.5C 101.667,237.501 101.5,288.501 101,339.5C 100.005,340.066 99.172,340.733 98.5,341.5C 97.3709,343.628 97.2042,345.961 98,348.5C 98.7504,349.126 99.5838,349.626 100.5,350C 172.5,350.667 244.5,350.667 316.5,350C 317.942,349.623 318.942,348.79 319.5,347.5C 322.059,347.198 324.393,347.532 326.5,348.5C 243.056,410.913 159.389,411.079 75.5,349C 54.8964,334.073 39.0631,315.239 28,292.5C 17.3119,260.705 11.4785,228.038 10.5,194.5C 10.1306,170.841 15.2972,148.507 26,127.5C 44.663,102.739 69.4963,88.0721 100.5,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#606060",
    d: "M 102.5,81.5 C 102.5,83.1667 102.5,84.8333 102.5,86.5C 128.169,86.6666 153.835,86.5 179.5,86C 180.244,84.9614 181.244,84.4614 182.5,84.5C 180.431,87.5725 177.764,89.9059 174.5,91.5C 174.5,91.1667 174.5,90.8333 174.5,90.5C 175.043,90.44 175.376,90.1067 175.5,89.5C 150.67,88.1711 126.003,88.1711 101.5,89.5C 101.492,92.5448 101.159,95.5448 100.5,98.5C 100.167,98.5 99.8333,98.5 99.5,98.5C 100.164,93.5275 100.497,88.5275 100.5,83.5C 101.167,82.8333 101.833,82.1667 102.5,81.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#616262",
    d: "M 309.5,77.5 C 310.117,77.6107 310.617,77.944 311,78.5C 311.495,80.4727 311.662,82.4727 311.5,84.5C 311.5,85.8333 311.5,87.1667 311.5,88.5C 287.833,88.5 264.167,88.5 240.5,88.5C 239.5,88.1667 238.833,87.5 238.5,86.5C 262.5,86.5 286.5,86.5 310.5,86.5C 310.296,83.4824 309.963,80.4824 309.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b4bec2",
    d: "M 101.5,89.5 C 126.003,88.1711 150.67,88.1711 175.5,89.5C 175.376,90.1067 175.043,90.44 174.5,90.5C 150.339,89.5024 126.006,89.169 101.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#afb7bb",
    d: "M 311.5,84.5 C 312.434,87.6557 313.101,90.9891 313.5,94.5C 312.662,94.8417 312.328,95.5084 312.5,96.5C 311.532,94.3926 311.198,92.0593 311.5,89.5C 288.167,89.5 264.833,89.5 241.5,89.5C 240.833,89.5 240.5,89.1667 240.5,88.5C 264.167,88.5 287.833,88.5 311.5,88.5C 311.5,87.1667 311.5,85.8333 311.5,84.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e1e8",
    d: "M 101.5,89.5 C 126.006,89.169 150.339,89.5024 174.5,90.5C 174.5,90.8333 174.5,91.1667 174.5,91.5C 171.573,92.7573 169.239,94.7573 167.5,97.5C 145.212,98.4788 122.879,98.8121 100.5,98.5C 101.159,95.5448 101.492,92.5448 101.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#777676",
    d: "M 196.5,82.5 C 193.437,86.5658 189.771,89.8991 185.5,92.5C 188.563,88.4342 192.229,85.1009 196.5,82.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e1e8",
    d: "M 241.5,89.5 C 264.833,89.5 288.167,89.5 311.5,89.5C 311.198,92.0593 311.532,94.3926 312.5,96.5C 302.522,97.832 292.189,98.4987 281.5,98.5C 271.167,98.3333 260.833,98.1667 250.5,98C 247,95.6658 244,92.8325 241.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e2e2d",
    d: "M 174.5,91.5 C 172.761,94.2427 170.427,96.2427 167.5,97.5C 169.239,94.7573 171.573,92.7573 174.5,91.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3c3b3b",
    d: "M 224.5,150.5 C 224.167,150.5 223.833,150.5 223.5,150.5C 223.667,132.164 223.5,113.83 223,95.5C 213.578,94.3491 204.078,94.1824 194.5,95C 193.944,95.3826 193.611,95.8826 193.5,96.5C 192.833,96.5 192.5,96.1667 192.5,95.5C 192.611,94.8826 192.944,94.3826 193.5,94C 203.744,93.1814 213.91,93.348 224,94.5C 224.5,113.164 224.667,131.83 224.5,150.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfe",
    d: "M 223.5,150.5 C 213.582,151.474 203.582,151.807 193.5,151.5C 193.5,133.167 193.5,114.833 193.5,96.5C 193.611,95.8826 193.944,95.3826 194.5,95C 204.078,94.1824 213.578,94.3491 223,95.5C 223.5,113.83 223.667,132.164 223.5,150.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9a9a99",
    d: "M 192.5,95.5 C 192.5,96.1667 192.833,96.5 193.5,96.5C 193.5,114.833 193.5,133.167 193.5,151.5C 203.582,151.807 213.582,151.474 223.5,150.5C 223.833,150.5 224.167,150.5 224.5,150.5C 224.047,151.458 223.381,152.292 222.5,153C 213.167,153.667 203.833,153.667 194.5,153C 193.692,152.692 193.025,152.192 192.5,151.5C 191.174,132.706 191.174,114.039 192.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2e2e9",
    d: "M 197.5,98.5 C 205.087,98.1858 212.587,98.5192 220,99.5C 220.667,115.167 220.667,130.833 220,146.5C 212.253,147.482 204.42,147.815 196.5,147.5C 196.182,131.089 196.516,114.756 197.5,98.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#121212",
    d: "M 236.5,86.5 C 237.167,86.5 237.833,86.5 238.5,86.5C 238.833,87.5 239.5,88.1667 240.5,88.5C 240.5,89.1667 240.833,89.5 241.5,89.5C 244,92.8325 247,95.6658 250.5,98C 260.833,98.1667 271.167,98.3333 281.5,98.5C 292.189,98.4987 302.522,97.832 312.5,96.5C 312.328,95.5084 312.662,94.8417 313.5,94.5C 313.5,96.1667 313.5,97.8333 313.5,99.5C 293.164,99.3334 272.831,99.5 252.5,100C 253.056,100.383 253.389,100.883 253.5,101.5C 253.5,103.5 252.5,104.5 250.5,104.5C 250.953,103.542 251.619,102.708 252.5,102C 246.663,97.3296 241.33,92.163 236.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#787777",
    d: "M 185.5,92.5 C 182.437,96.5658 178.771,99.8991 174.5,102.5C 177.563,98.4342 181.229,95.1009 185.5,92.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#909394",
    d: "M 99.5,99.5 C 121.193,98.8445 142.526,99.5112 163.5,101.5C 142.5,101.5 121.5,101.5 100.5,101.5C 100.326,103.861 99.9926,106.194 99.5,108.5C 99.1667,108.5 98.8333,108.5 98.5,108.5C 98.7038,105.482 99.0371,102.482 99.5,99.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#919495",
    d: "M 313.5,99.5 C 314.271,102.454 314.938,105.454 315.5,108.5C 315.167,108.5 314.833,108.5 314.5,108.5C 313.532,106.393 313.198,104.059 313.5,101.5C 293.5,101.5 273.5,101.5 253.5,101.5C 253.389,100.883 253.056,100.383 252.5,100C 272.831,99.5 293.164,99.3334 313.5,99.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e1e8",
    d: "M 163.5,101.5 C 165.146,103.812 167.146,105.812 169.5,107.5C 170.478,107.023 171.311,106.357 172,105.5C 172.494,107.134 172.66,108.801 172.5,110.5C 147.81,111.157 123.477,110.49 99.5,108.5C 99.9926,106.194 100.326,103.861 100.5,101.5C 121.5,101.5 142.5,101.5 163.5,101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e1e8",
    d: "M 253.5,101.5 C 273.5,101.5 293.5,101.5 313.5,101.5C 313.198,104.059 313.532,106.393 314.5,108.5C 291.524,110.49 268.191,111.157 244.5,110.5C 244.343,109.127 244.51,107.793 245,106.5C 247.528,107.934 249.362,107.267 250.5,104.5C 252.5,104.5 253.5,103.5 253.5,101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5c5c5d",
    d: "M 98.5,108.5 C 98.8333,108.5 99.1667,108.5 99.5,108.5C 123.477,110.49 147.81,111.157 172.5,110.5C 172.5,110.833 172.5,111.167 172.5,111.5C 147.833,111.5 123.167,111.5 98.5,111.5C 98.5,110.5 98.5,109.5 98.5,108.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e1e8",
    d: "M 172.5,113.5 C 172.5,116.5 172.5,119.5 172.5,122.5C 147.833,122.5 123.167,122.5 98.5,122.5C 98.2739,119.751 98.6072,117.084 99.5,114.5C 123.824,113.5 148.158,113.167 172.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e1e8",
    d: "M 316.5,118.5 C 317.434,119.568 317.768,120.901 317.5,122.5C 293.167,122.5 268.833,122.5 244.5,122.5C 244.5,119.5 244.5,116.5 244.5,113.5C 267.843,113.167 291.176,113.5 314.5,114.5C 315.189,116.444 315.689,118.444 316,120.5C 316.464,119.906 316.631,119.239 316.5,118.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6f7070",
    d: "M 98.5,111.5 C 123.167,111.5 147.833,111.5 172.5,111.5C 172.5,112.167 172.5,112.833 172.5,113.5C 148.158,113.167 123.824,113.5 99.5,114.5C 98.6072,117.084 98.2739,119.751 98.5,122.5C 123.167,122.5 147.833,122.5 172.5,122.5C 172.5,122.833 172.5,123.167 172.5,123.5C 147.5,123.5 122.5,123.5 97.5,123.5C 97.5,122.5 97.5,121.5 97.5,120.5C 97.2641,117.391 97.5975,114.391 98.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ababaa",
    d: "M 97.5,120.5 C 97.5,121.5 97.5,122.5 97.5,123.5C 122.5,123.5 147.5,123.5 172.5,123.5C 172.5,123.833 172.5,124.167 172.5,124.5C 147.167,124.5 121.833,124.5 96.5,124.5C 96.2322,122.901 96.5655,121.568 97.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5e5e5e",
    d: "M 96.5,124.5 C 121.833,124.5 147.167,124.5 172.5,124.5C 172.5,124.833 172.5,125.167 172.5,125.5C 147.5,125.5 122.5,125.5 97.5,125.5C 97.5,127.833 97.5,130.167 97.5,132.5C 97.1667,132.5 96.8333,132.5 96.5,132.5C 96.5,129.833 96.5,127.167 96.5,124.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e1e8",
    d: "M 172.5,125.5 C 172.5,128.5 172.5,131.5 172.5,134.5C 147.144,135.157 122.144,134.491 97.5,132.5C 97.5,130.167 97.5,127.833 97.5,125.5C 122.5,125.5 147.5,125.5 172.5,125.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#979999",
    d: "M 96.5,132.5 C 96.8333,132.5 97.1667,132.5 97.5,132.5C 122.144,134.491 147.144,135.157 172.5,134.5C 147.35,136.164 122.016,137.164 96.5,137.5C 96.1667,137.5 95.8333,137.5 95.5,137.5C 95.2155,135.585 95.5489,133.919 96.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#999a9a",
    d: "M 318.5,132.5 C 319.434,133.568 319.768,134.901 319.5,136.5C 294.5,136.5 269.5,136.5 244.5,136.5C 244.5,135.833 244.5,135.167 244.5,134.5C 268.833,134.5 293.167,134.5 317.5,134.5C 318.42,135.067 318.754,134.401 318.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0e0e0e",
    d: "M 167.5,97.5 C 166.71,98.7942 165.71,99.9609 164.5,101C 165.833,102.333 167.167,103.667 168.5,105C 170.537,104.517 172.537,103.684 174.5,102.5C 174.5,102.833 174.5,103.167 174.5,103.5C 173.503,120.992 173.17,138.659 173.5,156.5C 172.532,154.393 172.198,152.059 172.5,149.5C 172.5,148.833 172.5,148.167 172.5,147.5C 172.5,147.167 172.5,146.833 172.5,146.5C 172.5,143.5 172.5,140.5 172.5,137.5C 147.167,137.5 121.833,137.5 96.5,137.5C 122.016,137.164 147.35,136.164 172.5,134.5C 172.5,131.5 172.5,128.5 172.5,125.5C 172.5,125.167 172.5,124.833 172.5,124.5C 172.5,124.167 172.5,123.833 172.5,123.5C 172.5,123.167 172.5,122.833 172.5,122.5C 172.5,119.5 172.5,116.5 172.5,113.5C 172.5,112.833 172.5,112.167 172.5,111.5C 172.5,111.167 172.5,110.833 172.5,110.5C 172.66,108.801 172.494,107.134 172,105.5C 171.311,106.357 170.478,107.023 169.5,107.5C 167.146,105.812 165.146,103.812 163.5,101.5C 142.526,99.5112 121.193,98.8445 99.5,99.5C 99.5,99.1667 99.5,98.8333 99.5,98.5C 99.8333,98.5 100.167,98.5 100.5,98.5C 122.879,98.8121 145.212,98.4788 167.5,97.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#020202",
    d: "M 244.5,136.5 C 269.5,136.5 294.5,136.5 319.5,136.5C 319.5,137.5 319.5,138.5 319.5,139.5C 294.728,137.524 269.728,136.858 244.5,137.5C 243.167,137.167 243.167,136.833 244.5,136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cedee4",
    d: "M 244.5,137.5 C 269.728,136.858 294.728,137.524 319.5,139.5C 320.404,140.209 320.737,141.209 320.5,142.5C 319.549,143.919 319.216,145.585 319.5,147.5C 294.5,147.5 269.5,147.5 244.5,147.5C 244.5,144.167 244.5,140.833 244.5,137.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#686868",
    d: "M 250.5,104.5 C 249.362,107.267 247.528,107.934 245,106.5C 244.51,107.793 244.343,109.127 244.5,110.5C 268.191,111.157 291.524,110.49 314.5,108.5C 314.833,108.5 315.167,108.5 315.5,108.5C 316.051,111.807 316.384,115.14 316.5,118.5C 316.631,119.239 316.464,119.906 316,120.5C 315.689,118.444 315.189,116.444 314.5,114.5C 291.176,113.5 267.843,113.167 244.5,113.5C 244.5,116.5 244.5,119.5 244.5,122.5C 268.833,122.5 293.167,122.5 317.5,122.5C 318.207,125.786 318.54,129.119 318.5,132.5C 318.754,134.401 318.42,135.067 317.5,134.5C 317.296,131.482 316.963,128.482 316.5,125.5C 292.5,125.5 268.5,125.5 244.5,125.5C 244.5,128.5 244.5,131.5 244.5,134.5C 244.5,135.167 244.5,135.833 244.5,136.5C 243.167,136.833 243.167,137.167 244.5,137.5C 244.5,140.833 244.5,144.167 244.5,147.5C 269.5,147.5 294.5,147.5 319.5,147.5C 319.216,145.585 319.549,143.919 320.5,142.5C 320.5,144.833 320.5,147.167 320.5,149.5C 322.285,156.625 323.618,163.958 324.5,171.5C 323.833,171.5 323.167,171.5 322.5,171.5C 322.74,168.421 322.407,165.421 321.5,162.5C 245.836,161.5 170.17,161.167 94.5,161.5C 94.1667,163.5 93.8333,165.5 93.5,167.5C 93.1667,167.5 92.8333,167.5 92.5,167.5C 93.3681,157.486 94.3681,147.486 95.5,137.5C 95.8333,137.5 96.1667,137.5 96.5,137.5C 96.5,140.167 96.5,142.833 96.5,145.5C 95.9569,145.56 95.6236,145.893 95.5,146.5C 121.158,147.5 146.825,147.833 172.5,147.5C 172.5,148.167 172.5,148.833 172.5,149.5C 146.833,149.5 121.167,149.5 95.5,149.5C 95.1667,152.833 94.8333,156.167 94.5,159.5C 121.169,159.667 147.835,159.5 174.5,159C 173.748,158.329 173.414,157.496 173.5,156.5C 173.17,138.659 173.503,120.992 174.5,103.5C 174.5,121.5 174.5,139.5 174.5,157.5C 197.167,157.5 219.833,157.5 242.5,157.5C 242.667,139.497 242.5,121.497 242,103.5C 238.5,100 235,96.5 231.5,93C 232.167,92.3333 232.833,92.3333 233.5,93C 237.5,97 241.5,101 245.5,105C 247.197,105.384 248.863,105.218 250.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b5bfc3",
    d: "M 320.5,156.5 C 321.404,157.209 321.737,158.209 321.5,159.5C 294.759,159.833 268.759,159.499 243.5,158.5C 269.522,159.157 295.188,158.491 320.5,156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e1e8",
    d: "M 244.5,150.5 C 269.908,150.177 295.241,150.51 320.5,151.5C 320.5,153.167 320.5,154.833 320.5,156.5C 295.188,158.491 269.522,159.157 243.5,158.5C 244.265,155.904 244.599,153.237 244.5,150.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ccdbe1",
    d: "M 172.5,149.5 C 172.198,152.059 172.532,154.393 173.5,156.5C 173.414,157.496 173.748,158.329 174.5,159C 147.835,159.5 121.169,159.667 94.5,159.5C 94.8333,156.167 95.1667,152.833 95.5,149.5C 121.167,149.5 146.833,149.5 172.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b4bec2",
    d: "M 244.5,150.5 C 269.661,149.502 294.995,149.169 320.5,149.5C 320.5,150.167 320.5,150.833 320.5,151.5C 295.241,150.51 269.908,150.177 244.5,150.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b4bec2",
    d: "M 96.5,145.5 C 121.661,146.498 146.995,146.831 172.5,146.5C 172.5,146.833 172.5,147.167 172.5,147.5C 146.825,147.833 121.158,147.5 95.5,146.5C 95.6236,145.893 95.9569,145.56 96.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e1e8",
    d: "M 96.5,137.5 C 121.833,137.5 147.167,137.5 172.5,137.5C 172.5,140.5 172.5,143.5 172.5,146.5C 146.995,146.831 121.661,146.498 96.5,145.5C 96.5,142.833 96.5,140.167 96.5,137.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e1e8",
    d: "M 317.5,134.5 C 293.167,134.5 268.833,134.5 244.5,134.5C 244.5,131.5 244.5,128.5 244.5,125.5C 268.5,125.5 292.5,125.5 316.5,125.5C 316.963,128.482 317.296,131.482 317.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfdee5",
    d: "M 322.5,171.5 C 246.167,171.5 169.833,171.5 93.5,171.5C 93.5,170.167 93.5,168.833 93.5,167.5C 93.8333,165.5 94.1667,163.5 94.5,161.5C 170.17,161.167 245.836,161.5 321.5,162.5C 322.407,165.421 322.74,168.421 322.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#010101",
    d: "M 92.5,167.5 C 92.8333,167.5 93.1667,167.5 93.5,167.5C 93.5,168.833 93.5,170.167 93.5,171.5C 169.833,171.5 246.167,171.5 322.5,171.5C 323.167,171.5 323.833,171.5 324.5,171.5C 324.5,171.833 324.5,172.167 324.5,172.5C 247.167,172.5 169.833,172.5 92.5,172.5C 92.5,170.833 92.5,169.167 92.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#929698",
    d: "M 92.5,172.5 C 169.833,172.5 247.167,172.5 324.5,172.5C 325.77,176.785 325.77,181.119 324.5,185.5C 321.916,186.393 319.249,186.726 316.5,186.5C 316.167,186.5 315.833,186.5 315.5,186.5C 244.167,185.167 172.833,185.167 101.5,186.5C 98.8127,186.664 96.146,186.497 93.5,186C 92.944,185.617 92.6107,185.117 92.5,184.5C 91.1201,184.038 90.4534,183.038 90.5,181.5C 91.0641,178.435 91.7308,175.435 92.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e1e8",
    d: "M 92.5,184.5 C 92.2161,181.223 92.5495,178.057 93.5,175C 170.166,174.5 246.833,174.333 323.5,174.5C 324.207,177.786 324.54,181.119 324.5,184.5C 247.167,184.5 169.833,184.5 92.5,184.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5a5959",
    d: "M 315.5,186.5 C 315.5,237.5 315.5,288.5 315.5,339.5C 315.167,340.833 314.833,340.833 314.5,339.5C 314.5,321.833 314.5,304.167 314.5,286.5C 314.5,256.167 314.5,225.833 314.5,195.5C 243.833,195.5 173.167,195.5 102.5,195.5C 102.5,243.5 102.5,291.5 102.5,339.5C 102.167,340.167 101.833,340.833 101.5,341.5C 100.508,341.328 99.8417,341.662 99.5,342.5C 98.8333,342.5 98.5,342.167 98.5,341.5C 99.172,340.733 100.005,340.066 101,339.5C 101.5,288.501 101.667,237.501 101.5,186.5C 172.833,185.167 244.167,185.167 315.5,186.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 102.5,186.5 C 173.167,186.5 243.833,186.5 314.5,186.5C 314.5,189.167 314.5,191.833 314.5,194.5C 243.833,194.5 173.167,194.5 102.5,194.5C 102.5,191.833 102.5,189.167 102.5,186.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 314.5,286.5 C 301.48,285.014 291.147,289.514 283.5,300C 265.381,298.779 253.881,306.945 249,324.5C 248.222,329.584 248.389,334.584 249.5,339.5C 200.5,339.5 151.5,339.5 102.5,339.5C 102.5,291.5 102.5,243.5 102.5,195.5C 173.167,195.5 243.833,195.5 314.5,195.5C 314.5,225.833 314.5,256.167 314.5,286.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2e2e9",
    d: "M 193.5,217.5 C 221.573,214.247 245.739,222.247 266,241.5C 269.748,249.722 267.248,253.555 258.5,253C 231.582,228.246 202.248,224.913 170.5,243C 166.5,246.333 162.5,249.667 158.5,253C 151.167,253.997 148.334,250.83 150,243.5C 155.957,236.213 163.124,230.379 171.5,226C 178.609,222.267 185.942,219.433 193.5,217.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4a4a49",
    d: "M 355.5,220.5 C 356.465,221.721 356.298,223.054 355,224.5C 354.421,223.072 354.588,221.738 355.5,220.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#696968",
    d: "M 346.5,226.5 C 348.185,225.156 349.852,225.323 351.5,227C 349.803,227.384 348.137,227.218 346.5,226.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f5e5e",
    d: "M 355.5,229.5 C 357.089,228.379 358.756,228.546 360.5,230C 358.803,230.384 357.137,230.218 355.5,229.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#646463",
    d: "M 351.5,230.5 C 352.844,232.185 352.677,233.852 351,235.5C 350.616,233.803 350.782,232.137 351.5,230.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2e2e9",
    d: "M 199.5,238.5 C 220.75,237.012 238.917,243.679 254,258.5C 255.427,265.723 252.594,269.223 245.5,269C 220.778,248.46 196.112,248.46 171.5,269C 163.67,268.864 161.17,265.031 164,257.5C 174.135,247.851 185.968,241.518 199.5,238.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#646463",
    d: "M 335.5,251.5 C 330.507,251.997 329.507,254.164 332.5,258C 333.448,258.483 334.448,258.649 335.5,258.5C 332.048,260.257 330.048,259.09 329.5,255C 330.048,250.91 332.048,249.743 335.5,251.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3f3f3",
    d: "M 335.5,251.5 C 336.833,253.833 336.833,256.167 335.5,258.5C 334.448,258.649 333.448,258.483 332.5,258C 329.507,254.164 330.507,251.997 335.5,251.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#80807f",
    d: "M 335.5,251.5 C 339.5,253.833 339.5,256.167 335.5,258.5C 336.833,256.167 336.833,253.833 335.5,251.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6e6e6d",
    d: "M 355.5,263.5 C 357.558,264.824 359.225,264.324 360.5,262C 359.26,259.527 357.593,259.027 355.5,260.5C 358.067,257.734 360.067,258.234 361.5,262C 359.951,265.725 357.951,266.225 355.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cecece",
    d: "M 355.5,263.5 C 354.167,262.5 354.167,261.5 355.5,260.5C 357.593,259.027 359.26,259.527 360.5,262C 359.225,264.324 357.558,264.824 355.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2e2e9",
    d: "M 200.5,260.5 C 215.695,258.918 228.862,263.252 240,273.5C 240.817,276.964 240.483,280.298 239,283.5C 237.087,285.187 234.92,285.687 232.5,285C 216.448,272.341 200.448,272.341 184.5,285C 181.044,285.855 178.544,284.689 177,281.5C 176.333,278.833 176.333,276.167 177,273.5C 183.667,266.92 191.5,262.586 200.5,260.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2e2e9",
    d: "M 203.5,283.5 C 218.396,283.214 224.229,290.214 221,304.5C 213.193,313.235 205.193,313.568 197,305.5C 192.401,296.133 194.568,288.8 203.5,283.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2e2e9",
    d: "M 314.5,286.5 C 314.5,304.167 314.5,321.833 314.5,339.5C 292.833,339.5 271.167,339.5 249.5,339.5C 248.389,334.584 248.222,329.584 249,324.5C 253.881,306.945 265.381,298.779 283.5,300C 291.147,289.514 301.48,285.014 314.5,286.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.979
    },
    fill: "#d1e1e7",
    d: "M 315.5,186.5 C 315.833,186.5 316.167,186.5 316.5,186.5C 316.333,220.168 316.5,253.835 317,287.5C 323.639,289.803 328.806,293.969 332.5,300C 336.167,300.667 339.833,300.667 343.5,300C 345.944,294.117 350.277,290.617 356.5,289.5C 357.167,289.5 357.5,289.167 357.5,288.5C 374.461,288.412 384.627,296.746 388,313.5C 390.197,323.383 389.531,333.049 386,342.5C 384.445,345.055 382.278,346.888 379.5,348C 361.836,348.5 344.17,348.667 326.5,348.5C 324.393,347.532 322.059,347.198 319.5,347.5C 320.428,343.517 319.095,340.85 315.5,339.5C 315.5,288.5 315.5,237.5 315.5,186.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#929697",
    d: "M 102.5,339.5 C 151.5,339.5 200.5,339.5 249.5,339.5C 271.167,339.5 292.833,339.5 314.5,339.5C 314.833,340.833 315.167,340.833 315.5,339.5C 319.095,340.85 320.428,343.517 319.5,347.5C 318.942,348.79 317.942,349.623 316.5,350C 244.5,350.667 172.5,350.667 100.5,350C 99.5838,349.626 98.7504,349.126 98,348.5C 97.2042,345.961 97.3709,343.628 98.5,341.5C 98.5,342.167 98.8333,342.5 99.5,342.5C 99.5,344.5 99.5,346.5 99.5,348.5C 172.167,348.5 244.833,348.5 317.5,348.5C 317.5,346.167 317.5,343.833 317.5,341.5C 245.5,341.5 173.5,341.5 101.5,341.5C 101.833,340.833 102.167,340.167 102.5,339.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e1e8",
    d: "M 101.5,341.5 C 173.5,341.5 245.5,341.5 317.5,341.5C 317.5,343.833 317.5,346.167 317.5,348.5C 244.833,348.5 172.167,348.5 99.5,348.5C 99.5,346.5 99.5,344.5 99.5,342.5C 99.8417,341.662 100.508,341.328 101.5,341.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternetPlan);
export default __webpack_public_path__ + "static/media/internet-plan.e73815f7f506e74033c99d26ec9a19a7.svg";
export { ForwardRef as ReactComponent };